import DocsCode from './DocsCode';
import DocsColor from './DocsColor';
import DocsDescription from './DocsDescription';
import DocsGuidance from './DocsGuidance';
import DocsGuidanceHeader from './DocsGuidanceHeader';
import DocsPlayground from './DocsPlayground';
import DocsPropsTableHeader from './DocsPropsTableHeader';

export {
  DocsCode,
  DocsColor,
  DocsDescription,
  DocsGuidance,
  DocsGuidanceHeader,
  DocsPlayground,
  DocsPropsTableHeader,
};
